export const errorMessage = ( err : unknown ) => `An error occurred ${err}`;